{
  "version": 1,
  "asset_id": "701ef517-00be-472e-b85a-25a72de530d8",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/701ef517-00be-472e-b85a-25a72de530d8/hero-new-800.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/701ef517-00be-472e-b85a-25a72de530d8/hero-new-800.avif",
  "original_filename": "hero-new-800.avif",
  "size": 28839,
  "content_type": "image/avif",
  "created_at": "2026-07-25T03:21:09Z"
}
